import { httpClient } from "./httpClient";

type Role = {
  id: number;
  name: string;
  description?: string;
};

type Data = {
  roles: Role[];
};

export async function getRoles(
  application: number,
  environment: string
): Promise<Role[]> {
  try {
    const { data } = await httpClient.get<Data>(
      `/api/v1/roles/search?appId=${application}&environment=${environment}`
    );
    return data.roles;
  } catch (error) {
    throw error;
  }
}
